'use client';

import { usePathname, useRouter } from 'next/navigation';
import Pagination from 'components/_other/pagination/Pagination';
import { useEffect, useState } from 'react';
import { createQueryString } from '@/utils';

const PaginationComponent = props => {
  const {
    handleLinkAttributes = null,
    destinationElementId,
    parameters,
    searchParams,
    category,
    ...rest
  } = props;
  const defaultPageSize = process.env.NEXT_PUBLIC_PRODUCT_DEFAULT_PER_PAGE;

  const router = useRouter();
  const pathname = usePathname();
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const changePage = (page, pageSize = defaultPageSize) => {
    let dataToChange = {};

    const href = pathname +
      '?' +
      createQueryString(
        'page',
        page,
        searchParams,
        page === 1 ? 'page' : null
      );

    router.push(href, { scroll: true });
  };

  if (isBrowser) {
    return <Pagination {...rest} changePage={changePage} />;
  }
  return null;
};

export default PaginationComponent;
